import React from "react";
import useReveal from "../../../../lib/useReveal";
import portrait from "../../../../images/about-portrait.webp";
import Praan from "../../../../images/logo-praan.png";
import Aeg from "../../../../images/logo-aeg.png";
import Electrolux from "../../../../images/logo-electrolux.png";
import Vasart from "../../../../images/logo-vasart.png";
import MobiliFiver from "../../../../images/logo-mobili-fiver.png";
import Solidworks from "../../../../images/logo-solidworks.png";
import Photoshop from "../../../../images/logo-photoshop.png";
import Grasshopper from "../../../../images/logo-grasshopper.png";
import Onshape from "../../../../images/logo-onshape.png";
import Premiere from "../../../../images/logo-premiere.png";
import Rhino from "../../../../images/logo-rhino.png";
import AfterEffects from "../../../../images/logo-aftereffects.png";
import Keyshot from "../../../../images/logo-keyshot.png";
import "./about.scss";

const WORKED_WITH = [
  // The mark is a compact glyph rather than a wordmark, so it needs more
  // height than the others to carry the same optical weight.
  { src: Praan, name: "Praan", href: "https://www.praan.io", cls: "is-tall" },
  { src: Aeg, name: "AEG", href: "https://www.aeg.com" },
  { src: Electrolux, name: "Electrolux", href: "https://www.electrolux.com" },
  { src: Vasart, name: "Vasart" },
  { src: MobiliFiver, name: "Mobili Fiver", href: "https://www.mobilifiver.com" },
];

const TOOLS = [
  { src: Solidworks, name: "SolidWorks" },
  { src: Onshape, name: "Onshape" },
  { src: Rhino, name: "Rhino", cls: "is-tall" },
  { src: Grasshopper, name: "Grasshopper", cls: "is-line" },
  { src: Keyshot, name: "KeyShot", cls: "is-tall" },
  { src: Photoshop, name: "Adobe Photoshop" },
  { src: AfterEffects, name: "Adobe After Effects" },
  { src: Premiere, name: "Adobe Premiere Pro" },
];

const About = () => {
  const ref = useReveal();

  return (
    <section
      className="about"
      id="about"
      ref={ref}
      aria-labelledby="about-heading"
    >
      <div className="about__inner">
        <figure className="about__media" data-reveal>
          <img
            src={portrait}
            alt="Delaina Fernandes at work on an industrial design project"
            loading="lazy"
            decoding="async"
            width="1400"
            height="1494"
          />
        </figure>

        <div className="about__body" data-reveal style={{ "--d": 1 }}>
          <h2 className="about__heading" id="about-heading">
            About
          </h2>

          <div className="about__prose">
            <p>Hi, I'm Delaina!</p>
            <p>
              I am an Industrial Designer and multidisciplinary designer with
              over 2 years experience working on projects that have an impact
              on people and design systems. My areas of expertise include
              Industrial Design &amp; 3D Product Visualization.
            </p>
            <p>
              I started my career working as an intern at Forbes Marshall which
              is a leading provider of energy conservation and automation
              solutions for the process industry for over 75 years. I then
              proceeded to join Praan which is a venture-backed deep tech
              start-up. They use breakthrough patent-pending technology to
              address real climate change concerns by creating filter-less air
              purification devices that capture particulates and carbon dioxide
              from ambient air. This is when I realized how advanced technology
              may tackle real-world problems for future generations
            </p>
            <p>
              Currently, working as a Freelance Industrial &amp; Visual
              Designer, focusing on bringing my creativity, visual aesthetic and
              problem solving mindset to clients and strengthen their business
              through Design.
            </p>
          </div>
        </div>
      </div>

      <div className="about__marks" data-reveal>
        <div className="about__mark-group">
          <h3 className="u-mono about__mark-label">Previously worked with</h3>
          <ul className="about__logos">
            {WORKED_WITH.map((l) => {
              const mark = (
                <img
                  src={l.src}
                  alt={l.name}
                  className={l.cls}
                  loading="lazy"
                  decoding="async"
                />
              );
              return (
                <li key={l.name}>
                  {l.href ? (
                    <a href={l.href} target="_blank" rel="noreferrer">
                      {mark}
                    </a>
                  ) : (
                    mark
                  )}
                </li>
              );
            })}
          </ul>
        </div>

        <div className="about__mark-group">
          <h3 className="u-mono about__mark-label">Software</h3>
          <ul className="about__logos about__logos--tools">
            {TOOLS.map((l) => (
              <li key={l.name}>
                <img
                  src={l.src}
                  alt={l.name}
                  className={l.cls}
                  loading="lazy"
                  decoding="async"
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default About;
